window.requestTimeout = (fn, delay) => {
  const start = performance.now();
  const handle = {};

  const loop = () => {
    const current = performance.now();
    const delta = current - start;

    if (delta >= delay) {
      fn.call();
    } else {
      handle.value = requestAnimationFrame(loop);
    }
  }

  handle.value = requestAnimationFrame(loop);

  return handle;
}

window.cancelTimeout = (handle) => {
  window.cancelAnimationFrame(handle.value);
};
